import { render, staticRenderFns } from "./ProductsCompareOverlay.vue?vue&type=template&id=022a057a&"
import script from "./ProductsCompareOverlay.vue?vue&type=script&lang=js&"
export * from "./ProductsCompareOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports